import {
  createRouter,
  createWebHistory,
} from 'vue-router'

import HomeRouter from './view/HomeRouter.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeRouter,
    // meta: { title: "Accueil" },
    meta: { title: 'Tableau de bord' },
  },
  // { path: "/home", component: HomeView },
  {
    /// DEPULICATE
    path: '/dashboard',
    redirect: '/',
    /*

    name: "dashboard",
    component: () => import("@/view/Dashboard.vue"),
    meta: { title: "Tableau de bord" }, */
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/view/WelcomeGuide.vue'),
    meta: { title: 'Bienvenue' },
  },
  /// convo and talk
  {
    path: '/landing',
    name: 'landing',
    component: () => import('@/view/brochure/BrochureLanding.vue'),
    meta: { title: 'Bienvenue' },
  },
  {
    path: '/en',
    name: 'landing_en',
    component: () => import('@/view/brochure/BrochureLanding.vue'),
    meta: { title: 'Welcome' },
  },
  {
    path: '/landing_mar12', // old stuff
    component: () => import('@/view/brochure/BrochureLanding_mar12.vue'),
    meta: { title: 'Bienvenue' },
  },
  {
    path: '/landing_guru', // old stuff
    name: 'landing_guru',
    component: () => import('@/view/brochure/BrochureLanding_guru.vue'),
    meta: { title: 'Bienvenue' },
  },

  {
    path: '/upgrade',
    component: () => import('@/view/Upgrade.vue'),
    meta: { title: 'Mise à niveau' },
  },

  {
    path: '/client',
    name: 'clients',
    component: () => import('@/view/Clients.vue'),
    meta: { title: 'Clients' },
  },

  {
    path: '/client/dummy',
    name: 'clientdummy',
    component: () => import('@/view/Client_dummy.vue'),
    meta: { title: 'Client' },
  },

  {
    path: '/client/:id',
    name: 'client',
    component: () => import('@/view/Client.vue'),
    meta: { title: 'Client' },
    children: [
      {
        path: 'done/:convoId',
        component: () => import('@/view/ClientActivitySummary.vue'),
        meta: { title: 'Résumé d\'activité' },
      },
      {
        path: 'convo/:convoId',
        component: () => import('@/view/ClientActivitySummary.vue'),
        meta: { title: 'Conversation' },
      },
      {
        path: 'extra/:extraId',
        component: () => import('@/view/ClientExtraPanel.vue'),
        meta: { title: 'Extra' },
      },
      {
        path: 'fiche',
        name: 'clientFiche2',
        component: () => import('@/view/ClientFiche.vue'),
        meta: { title: 'Fiche client' },
      },
      {
        path: 'memory',
        name: 'ClientMemory',
        component: () => import('@/view/ClientMemory.vue'),
        meta: { title: 'Mémoire client' },
      },
      {
        path: 'note',
        name: 'notePanel',
        component: () => import('@/components/Soon.vue'),
        meta: { title: 'Notes' },
      },
      {
        path: 'talk',
        name: 'talk26',
        component: () => import('@/view/Convo.vue'),
        meta: { title: 'Discussion' },
      },
    ],
  },
  /*
  {
    path: "/activities",
    name: "ActivityListing",
    component: () => import("@/view/ActivityListing.vue"),
    meta: { title: "Activités" }
  },
*/

  {
    path: '/extras',
    name: 'extras',
    component: () => import('@/view/ExtraListing.vue'),
    meta: { title: 'Extras' },
  },
  {
    path: '/extras/:id',
    name: 'extraDetails',
    component: () => import('@/view/ExtraDetails.vue'),
    meta: { title: 'Détails de l\'extra' },
  },

  {
    path: '/bibli',
    name: 'bibli',
    component: () => import('@/view/Bibli.vue'),
    meta: { title: 'Bibliothèque' },
    children: [
      {
        path: '',
        name: 'bibliHome',
        component: () => import('@/view/ActivityListing.vue'),
        meta: { title: 'Activités' },
      },

      {
        path: 'extras',
        component: () => import('@/view/ExtraListing.vue'),
        meta: { title: 'Extras' },
      },
    ],
  },
  {
    path: '/bibli/activities/:slug',
    name: 'ActivityListingDetails',
    component: () => import('@/view/ActivityListingDetails.vue'),
    meta: { title: 'Détails de l\'activité' },
  },
  {
    path: '/extra/:extraId',
    name: 'standaloneExtra',
    component: () => import('@/view/StadaloneExtra.vue'),
    meta: { title: 'Extra' },
  },

  {
    path: '/supa',
    name: 'supa',
    component: () => import('@/view/SupaDebug.vue'),
    meta: { title: 'Supa Debug' },
  },

  {
    path: '/client/:id/fiche2',
    name: 'clientFiche',
    component: () => import('@/view/ClientFiche.vue'),
    meta: { title: 'Fiche client' },
  },
  {
    path: '/client/:id/convo/dummy',
    name: 'ClientActivitySummaryDummy2',
    component: () => import('@/view/ClientActivitySummaryDummy.vue'),
    meta: { title: 'Résumé d\'activité' },
  },
  {
    path: '/client/:id/convo2/:convoId',
    name: 'ClientActivitySummaryConvo',
    component: () => import('@/view/ClientActivitySummary.vue'),
    meta: { title: 'Résumé d\'activité' },
  },

  /// convo and talk
  /*
  {
    path: "/talk",
    name: "talk",
    component: () => import("@/view/Talk.vue"),
    meta: { title: "Discussion" }
  },
  {
    path: "/talk/eleven/:eleven",
    name: "talk2",
    component: () => import("@/view/Talk.vue"),
    meta: { title: "Discussion" }
  },
  {
    path: "/talk/jwt/:jwt",
    name: "talk3",
    component: () => import("@/view/Talk.vue"),
    meta: { title: "Discussion" }
  },

*/

  {
    path: '/invite-client',
    name: 'invitecleint',
    component: () => import('@/view/InviteClient.vue'),
    meta: { title: 'Inviter un client' },
  },

  /// patient activity
  {
    path: '/start-activity/:id',
    name: 'startActivity',
    component: () => import('@/view/ActivityStart.vue'),
    meta: { title: 'Commencer l\'activité' },
  },

  {
    path: '/styleguide',
    name: 'styleguide',
    component: () => import('@/view/Styleguide.vue'),
    meta: { title: 'Guide de style' },
  },

  {
    path: '/realtime-activity/:id',
    name: 'realtimeActivity',
    component: () => import('@/view/RealtimeActivity.vue'),
    meta: { title: 'Activité en temps réel' },
    // component: () => import("@/view/Convo.vue"),
  },

  {
    path: '/form-activity/:id',
    name: 'formActivity',
    component: () => import('@/view/FormActivity.vue'),
    meta: { title: 'Activité de formulaire' },
    // component: () => import("@/view/Convo.vue"),
  },

  {
    path: '/wiso/:id',
    name: 'convo',
    component: () => import('@/view/Convo.vue'),
    meta: { title: 'Conversation' },
  },

  {
    path: '/blog',
    name: 'blogListing',
    component: () => import('@/view/Blogs.vue'),
    meta: { title: 'Blog' },
  },

  {
    path: '/blog/:pathMatch(.*)*',
    name: 'blogArticle',
    component: () => import('@/view/BlogArticle.vue'),
    meta: { title: 'Article de blog' },
  },

  // v2 - using agora.
  {
    path: '/meet',
    name: 'host-home',
    component: () => import('@/view/MeetHome.vue'),
    meta: { title: 'Réunions' },
  },
  /*
  {
    path: "/host/:roomId",
    name: "host-room",
    component: () => import("@/view/VideoHost.vue"),
    meta: { title: "Héberger une réunion" }
  }, */
  {
    path: '/meet/done',
    name: 'meetDone',
    component: () => import('@/view/VideoDone.vue'),
    meta: { title: 'Réunion terminée' },
    props: true,
  },
  {
    path: '/meet/:roomId',
    name: 'meet',
    component: () => import('@/view/VideoRoot.vue'),
    meta: { hasVideoCall: true, title: 'Réunion' },
    props: true,
  },

  // Redirect from /host to /meet (for backward compatibility)
  /*
  {
    path: "/host/:roomId",
    name: "host-room",
    beforeEnter: (to, from, next) => {
      next({ name: "meet", params: { roomId: to.params.roomId } });
    },
    meta: { title: "Héberger une réunion" }
  }, */

  /* we phase this out, will redirect to the /meet url
  {
    path: "/hostOLD/:roomId",
    name: "host-room",
    component: () => import("@/view/VideoHost.vue"),
    meta: { title: "Héberger une réunion" }
  },

  {
    path: "/meetOLD/:roomId",
    name: "meetOld",
    component: () => import("@/view/VideoJoin.vue"),
    meta: { title: "Réunion" },
    props: true,
  },
 */
  {
    path: '/meets/:id',
    name: 'MeetingDetails',
    component: () => import('@/view/MeetingDetails.vue'),
    meta: { title: 'Détails de la réunion' },
    props: true,
  },
  {
    path: '/meets/:id/edit',
    name: 'EditMeeting',
    component: () => import('@/view/EditMeetingPage.vue'),
    meta: { title: 'Modifier la réunion' },
    props: true,
  },

  ////////
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/components/auth/Auth.vue'),
    meta: { title: 'Authentification' },
  },

  {
    path: '/debuter/merci',
    // name: "debuter",
    name: 'PatientSignupDone',
    component: () => import('@/view/PatientSignupDone.vue'),
    meta: { title: 'Inscription terminée' },
  },
  {
    path: '/debuter/:id',
    name: 'debuterInvite',
    component: () => import('@/view/PatientSignup.vue'),
    meta: { title: 'S\'inscrire' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/auth/Auth.vue'),
    meta: { title: 'Connexion' },
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/components/auth/Auth.vue'),
    meta: { title: 'S\'inscrire' },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/view/Privacy.vue'),
    meta: { title: 'Politique de confidentialité' },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/view/Terms.vue'),
    meta: { title: 'Conditions d\'utilisation' },
  },
  {
    path: '/beta',
    name: 'beta',
    component: () => import('@/view/BetaRegister.vue'),
    meta: { title: 'Inscription à la bêta' },
  },

  {
    path: '/testRecord',
    name: 'testRecord',
    component: () => import('@/view/dev/testRecord.vue'),
    meta: { title: 'Test d\'enregistrement' },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/view/Settings.vue'),
    meta: { title: 'Paramètres' },
  },

  {
    path: '/help',
    name: 'help',
    component: () => import('@/view/Help.vue'),
    meta: { title: 'Aide' },
  },

  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/view/Feedback.vue'),
    meta: { title: 'Commentaires' },
  },

  /// admin console
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/view/admin/AdminConsole.vue'),
    meta: { title: 'Admin' },
    children: [
      {
        path: 'media',
        name: 'AdminMedias',
        component: () => import('@/view/admin/AdminMedias.vue'),
        meta: { title: 'Admin - Médias' },
      },
      {
        path: 'db/:collection?',
        name: 'AdminDb',
        component: () => import('@/view/admin/AdminDbData.vue'),
        meta: { title: 'Admin - Base de données' },
      },
      {
        path: 'meets',
        name: 'AdminMeetings',
        component: () => import('@/view/admin/AdminMeetings.vue'),
        meta: { title: 'Admin - Meetings' },
      },
      {
        path: 'done/:convoId',
        component: () => import('@/view/ClientActivitySummary.vue'),
        meta: { title: 'Admin - Résumé d\'activité' },
      },
      {
        path: ':pathMatch(.*)*',
        name: 'NotFoundAdmin',
        component: () => import('@/view/Page404.vue'),
        meta: { title: 'Admin - Page non trouvée' },
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    component: () => import('@/view/Page404.vue'),
    meta: { title: 'Page non trouvée' },
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/view/Page404.vue'),
    meta: { title: 'Page non trouvée' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (e.g., navigating back/forward), return it
    if (savedPosition) {
      return savedPosition
    }

    // Always scroll to the top when navigating to a new route
    return { top: 0 }
  },
})

const BRAND = 'Selfwise'

router.beforeEach(async (to, from, next) => {
  // Use our title utility directly in router for faster title updates
  // This happens before component is mounted, eliminating the delay
  /*
  usePageTitle({
    title: to.meta.title ? () => to.meta.title : () => null,
    brand: BRAND,
    titleFirst: true
  });
  */
  next()
})

export default router
